import { view } from '@yola/ws-sdk';

const { deviceModes, deviceModeBreakpoints, breakpointModifiers } = view;

export const HIDE_ON_TARGETS = {
  ALL: 'all',
  DESKTOP: deviceModes.DESKTOP,
  TABLET: deviceModes.TABLET,
  MOBILE: deviceModes.MOBILE,
};

const getOnlyBreakpoint = (deviceMode) =>
  deviceModeBreakpoints[deviceMode][breakpointModifiers.ONLY];

export const ALL_DEVICES_BREAKPOINT = '';

const DESKTOP_BREAKPOINT = getOnlyBreakpoint(deviceModes.DESKTOP);
const TABLET_BREAKPOINT = getOnlyBreakpoint(deviceModes.TABLET);
const MOBILE_BREAKPOINT = getOnlyBreakpoint(deviceModes.MOBILE);

export const HIDE_ON_TARGET_TO_BREAKPOINT = {
  [HIDE_ON_TARGETS.ALL]: ALL_DEVICES_BREAKPOINT,
  [HIDE_ON_TARGETS.DESKTOP]: DESKTOP_BREAKPOINT,
  [HIDE_ON_TARGETS.TABLET]: TABLET_BREAKPOINT,
  [HIDE_ON_TARGETS.MOBILE]: MOBILE_BREAKPOINT,
};

export const DEVICE_BREAKPOINTS = [DESKTOP_BREAKPOINT, TABLET_BREAKPOINT, MOBILE_BREAKPOINT];
